// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"c566c915","253":"c566c915","410":"c566c915","450":"c566c915","786":"c566c915","847":"c566c915","981":"e3416fb2"}[chunkId] + ".chunk.css";
};